import { render, staticRenderFns } from "./index.vue?vue&type=template&id=db51f574"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db51f574')) {
      api.createRecord('db51f574', component.options)
    } else {
      api.reload('db51f574', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=db51f574", function () {
      api.rerender('db51f574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjSelectBrand/index.vue"
export default component.exports